export const CONTROLLER_STATES = {
    BLOCKED: 0,
    BOOT: 1,
    MENU: 2,
    GAME: 3
} as const;

export type ControllerState = typeof CONTROLLER_STATES[keyof typeof CONTROLLER_STATES];